import { trimEnd } from 'lodash';
import { urijs } from '../helpers/urijs';
// normalizes url for unicode support in server side
export const normalizeUrl = (url) => new urijs(url).normalize().toString();
// decodes origin and pathname to readable unicode characters
// cannot decode search as it might contain encoded '#' character
export const readableUrl = (uri) => {
    const url = new urijs(uri);
    const pathname = url.pathname();
    const origin = url.origin();
    let readablePart = new urijs(origin + pathname).readable();
    if (pathname === '/' && !uri.endsWith('/')) {
        readablePart = trimEnd(readablePart, '/');
    }
    return readablePart + url.search() + url.hash();
};
export const joinUrlPaths = (baseUrl, paths) => urijs
    .joinPaths(urijs(baseUrl).pathname(), ...paths)
    .absoluteTo(baseUrl)
    .toString();
//# sourceMappingURL=uri.js.map